module.exports = __webpack_public_path__ + "static/media/carret_up.1c7c7815.svg";